///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { ILoadingDirectiveConfig, SuiLoadingMaskComponent, SuiLoadingService } from '@siklu/sui-lib/components';

@Injectable({
    providedIn: 'root'
})
export class PreloaderService {
    private readonly maskConfig = {
        showLoaderImage: true,
        loaderText: undefined,
        hasFadeEffect: true,
        maskEl: SuiLoadingMaskComponent
    } as ILoadingDirectiveConfig;

    constructor(private readonly loader: SuiLoadingService) {
        this.loader.setLoadingConfigInstance(LoaderIds.GLOBAL_LOADER_ID, this.maskConfig);
    }

    public show(maskId = LoaderIds.GLOBAL_LOADER_ID): void {
        if (this.loader.isLoading({ key: maskId })) {
            return;
        }

        this.loader.setLoadingConfigInstance(maskId, this.maskConfig);
        this.loader.add({ key: maskId });
    }

    public hide(maskId = LoaderIds.GLOBAL_LOADER_ID): void {
        this.loader.remove({ key: maskId });
    }

    public getMainLoaderId(): string {
        return LoaderIds.GLOBAL_LOADER_ID;
    }

    public getLoadingConfig(key: string): ILoadingDirectiveConfig {
        return this.loader.getLoadingConfigInstance(key);
    }
}

export enum LoaderIds {
    GLOBAL_LOADER_ID = 'globalLoaderId',
    BOM_CONFIG_DIALOG_PRELOADER_ID = 'bomConfigDialogLoaderId',
    STYLE_PREFERENCES_DIALOG_PRELOADER_ID = 'StylePreferencesLoaderId',
    PRODUCT_ENGINE_DIALOG_LOADER_ID = 'productEngineLoaderId',
    PRODUCT_RADIO_DIALOG_PRELOADER_ID = 'productRadioDialogLoaderId',
    CUSTOMERS_LOCATION_DIALOG_LOADER_ID = 'customersLocationDialogLoaderId',
    CUSTOMER_DIALOG_LOADER_ID = 'customerDialogLoaderId',
    PRODUCT_SERVICE_DIALOG_PRELOADER_ID = 'productServiceDialogLoaderId',
    PROJECT_DIALOG_PRELOADER_ID = 'projectDialogLoaderId',
    PROJECT_MOVE_DIALOG_PRELOADER_ID = 'projectMoveDialogLoaderId',
    PROJECT_CLONE_DIALOG_PRELOADER_ID = 'projectCloneDialogLoaderId',
    PROJECT_IMPORT_DIALOG_PRELOADER_ID = 'projectImportDialogLoaderId',
    USER_DIALOG_PRELOADER_ID = 'userDialogLoaderId',
    PRODUCT_MIGRATION_DIALOG_PRELOADER_ID = 'productMigrationLoaderId',
    PRODUCT_DIFF_DIALOG_PRELOADER_ID = 'productDiffLoaderId',
    BOM_SUMMARY_PRELOADER_ID = 'bomSummaryPreloaderId',
    SALE_DELETE_DIALOG = 'saleDeleteDialogId',
    CHANGE_PASSWORD_ID = 'changePasswordId',
    PRODUCT_ENGINE_MAPPING_ID = 'productEngineMappingId',
    PRODUCT_SERVICE_ID = 'productServiceId',
    REPORT_P2P_INFO_ID = 'reportP2PInfoId',
    REPORT_P2MP_INFO_ID = 'reportP2MPInfoId',
    CONSTRAINT_COMPLIANCE_ID = 'constraintComplianceId',
    UPDATE_EULA_ID = 'updateEULAId',
    ACCEPT_EULA_ID = 'acceptEULAId',
    BUG_REPORT_ID = 'bugReportId',
    DELETE_FOLDER_ID = 'deleteFolderId',
    DELETE_PROJECT_ID = 'deleteProjectId',
    UPLOAD_RADIO_ID = 'uploadRadioLoaderKey',
    UPLOAD_ANTENNA_ID = 'uploadAntennaLoaderKey',
    DELETE_RADIO_ID = 'deleteRadioLoaderKey',
    DELETE_ANTENNA_ID = 'deleteAntennaLoaderKey',
    EMAIL_VERIFICATION_ID = 'emailVerificationKey'
}
